import { RoomChatBot } from "@/core/api/room.chatBot.api"

export default {
  sendChatMessage: async ({dispatch, commit, getters, rootGetters}, data) => {
    commit('PUT_CHAT', data)
    await RoomChatBot.sendChatMessage(data)
  },
  updateSendChatStatus: ({dispatch, commit, getters, rootGetters}, data) => {
    commit('UPDATE_SEND_STATUS', data)
  },
}
